The name of the sub-organization.

This identifies a subsidiary or regional entity within the hiring organization.
